const Payments = {
  paymentPath: (id: string) => `/CheckoutApi/${id}`,
  paymentsPath: (type: string) => `ExternalSale/myReservations?type=${type}`,
  accountsReceivable: () => `Financial/AccountsReceivable`,
  getBilletAgency: (id: string) => `Financial/Boleto/${id}`,
};

export default Payments;
